import { useState } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonTextarea,
    IonCol,
    IonFooter,
    IonGrid,
    IonRow,
    IonIcon
} from '@ionic/react';
import { getSmsTemplates, getSmsTemplate } from '../firebase/smsTemplates';
import { saveAndSendSms } from '../firebase/sms';

import dateFormat from 'dateformat';
import { chevronBack } from 'ionicons/icons';
import { getUser } from '../firebase/users';

function removePolishCharacters(text: string) {
    const expression = /[ąćęłńóśźż]/gi;

    const replacements = {
        'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
        'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N', 'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
    };
    //@ts-ignore
    return text.replace(expression, (letter) => replacements[letter]);
}

const SmsDialog = ({
    onDismiss, initData
}: {
    onDismiss: (data: any, role: string) => void;
    initData: any
}) => {


    const [text, setText] = useState('');
    const [sender, setSender] = useState('');
    const [template, setTemplate] = useState('');
    const [receiver, setReceiver] = useState(initData.receivers[0].number);

    const templates = getSmsTemplates();
    var defaultTemplate = templates[0];
    for (var i = 0; i < templates.length; i++) {
        if (templates[i].default) {
            defaultTemplate = templates[i];
            break;
        }
    }
    if (template !== '') {
        defaultTemplate = getSmsTemplate(template);
    } else {
        updateTemplate(defaultTemplate.id);
    }



    function hide() {
        onDismiss(null, 'cancel')
    }

    function updateTemplate(id: string) {

        setTemplate(id);
        let t = getSmsTemplate(id);

        var text = t.text.replace('[DATA]', dateFormat(initData.date, "yyyy-mm-dd"));
        text = text.replace('[CZAS]', dateFormat(initData.date, "HH:MM"));
        text = text.replace('[LINK]', "https://egabinet.wiq.pl/c/cwir/"+initData.event.id+"/t");
        let user = getUser(initData.userId);
        if(user !== undefined && user !== null){
            text = text.replace('[TERAPEUTA]', user.name+" "+user.surname);
        }
        text = removePolishCharacters(text);
        setText(text);
        setSender(t.sender);
    }

    async function sendSms() {
        let data = {
            receiver: receiver,
            sender: sender,
            text: removePolishCharacters(text),
            event: initData.event,
            clientId: initData.clientId,
            templateId: template
         }
        await saveAndSendSms(data);
        hide();
    }

    //2022 - 11 - 03 o 08: 00 odbędzie się wizyta.Odpisz TAK aby potwierdzić obecność lub NIE aby zmienić termin. Gabinet Terapeutyczny Żaneta Łopata.
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => hide()}>
                            <IonIcon icon={chevronBack}/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonItem>
                    <IonLabel>Nadawca</IonLabel>
                    <IonInput slot="end" style={{textAlign:"right"}} readonly={true} value={sender} placeholder="nadawca" />
                </IonItem>
                <IonItem>
                    <IonLabel>Adresat</IonLabel>
                    <IonSelect style={{maxWidth:"100%"}} interface="popover" value={receiver} onIonChange={(e) => { setReceiver(e.detail.value) }} placeholder="Wybierz adresata">
                        {initData.receivers.map((t:any) => {
                            return <IonSelectOption style={{maxWidth:"100%"}} key={t.number} value={t.number}>{t.name+" ("+t.number+")"}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>

                <IonItem>
                    <IonLabel>Szablon</IonLabel>
                    <IonSelect style={{maxWidth:"100%"}} interface="popover" value={defaultTemplate.id} onIonChange={(e) => { updateTemplate(e.detail.value) }} placeholder="Wybierz szablon">
                        {templates.map(t => {
                            return <IonSelectOption key={t.id} value={t.id}>{t.topic}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel position="floating">Treść</IonLabel>
                    <IonTextarea placeholder="wiadomość" autoGrow={true} value={text} onIonChange={(e) => { setText(e.detail.value + "") }} ></IonTextarea>
                </IonItem>




            </IonContent>

            <IonFooter>
                <IonGrid>
                    <IonRow style={{ textAlign: "center" }}>
                        <IonCol>
                            <IonButton color="primary" onClick={() => { sendSms() }}>wyślij</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
        </IonPage>
    );
};

export default SmsDialog;

